import React, { useState, FC, FormEvent } from "react";
import { connect } from "react-redux";
import { updateUser } from "../../store/actions/auth";
import { RootState } from "../../store/reducers";
import { User } from "../../models/user";

interface Props {
  userInfo: User;
  updateUser: Function;
}

const AccountInfo: FC<Props> = ({ userInfo, updateUser }) => {
  const [userinfo, setUserinfo] = useState<{
    username: string;
    accountType: string;
    imgFile: Blob | null;
    img: string;
    bio: string;
    email: string;
    firstName: string;
    id: string;
    lastName: string;
    location: { city: string; country: string };
    website: string;
  }>({
    username: userInfo.username,
    accountType: userInfo.accountType,
    imgFile: null,
    img: "",
    bio: userInfo.bio,
    email: userInfo.email,
    firstName: userInfo.firstName,
    id: userInfo.id,
    lastName: userInfo.lastName,
    location: userInfo.location,
    website: userInfo.website,
  });

  const onChange = (e: FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setUserinfo({
      ...userinfo,
      [e.currentTarget.id]: e.currentTarget.value,
      location: {
        city:
          e.currentTarget.id === "city"
            ? e.currentTarget.value
            : userinfo.location.city,
        country:
          e.currentTarget.id === "country"
            ? e.currentTarget.value
            : userinfo.location.country,
      },
    });
  };

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    updateUser(userinfo);
  };

  const {
    username,
    firstName,
    lastName,
    email,
    location: { city, country },
    bio,
    website,
  } = userinfo;

  return (
    <div style={{ marginBottom: "6em" }}>
      <form
        onSubmit={onSubmit}
        className=" bg-dark uk-padding-small uk-margin-large-bottom uk-border-rounded uk-width-3-5@m uk-width-5-6@s"
      >
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">Username</label>
          <input
            type="text"
            className="uk-input"
            value={username}
            onChange={onChange}
            id="username"
            placeholder="Username"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">First name</label>
          <input
            type="text"
            className="uk-input"
            value={firstName || ""}
            onChange={onChange}
            id="firstName"
            placeholder="John"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">Last name</label>
          <input
            type="text"
            className="uk-input"
            value={lastName || ""}
            onChange={onChange}
            id="lastName"
            placeholder="Doe"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">Email</label>
          <input
            type="email"
            className="uk-input"
            value={email}
            disabled
            placeholder="Email"
            style={{ cursor: "not-allowed", color: "#777 !important" }}
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">City</label>
          <input
            type="text"
            className="uk-input"
            value={city || ""}
            onChange={onChange}
            id="city"
            placeholder="City"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">Country</label>
          <input
            type="text"
            className="uk-input"
            value={country || ""}
            onChange={onChange}
            id="country"
            placeholder="Country"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">Website</label>
          <input
            type="text"
            className="uk-input"
            value={website || ""}
            onChange={onChange}
            id="website"
            placeholder="example.com"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label app-text">Bio</label>
          <textarea
            className="uk-textarea"
            value={bio || ""}
            onChange={onChange}
            id="bio"
            rows={5}
            placeholder="Bio"
          ></textarea>
        </div>
        <div data-uk-form-custom>
          <input
            onChange={(e) => {
              if (e.target.files) {
                if (e.target.files[0]) {
                  setUserinfo({
                    ...userinfo,
                    imgFile: e.target.files[0],
                    img: e.target.files[0].name,
                  });
                  let btn = document.getElementById("upload-button");
                  if (btn) {
                    btn.innerHTML = e.target.files[0].name;
                  }
                }
              }
            }}
            type="file"
            id="file"
          />
          <button
            className="uk-button uk-border-rounded"
            type="button"
            id="upload-button"
          >
            <i className="material-icons-outlined">cloud_upload</i>
            Upload Profile
          </button>
        </div>
        <div className="uk-margin-small-top uk-flex-center">
          <input
            type="submit"
            className="uk-button uk-border-rounded"
            value="Update"
          />
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  userInfo: state.auth.user,
});

export default connect(mapStateToProps, { updateUser })(AccountInfo);
